import { all } from 'redux-saga/effects';
import invoicesSaga from './invoices/saga';
import transactionsSaga from './transactions/saga';
import creditTerms from './creditTerms/saga';
import payablesSaga from './payables/saga';
import dashboardSaga from './dashboard/saga';
import reconciliationSaga from './reconciliation/saga';

export default function* () {
  yield all([
    invoicesSaga(),
    transactionsSaga(),
    creditTerms(),
    payablesSaga(),
    dashboardSaga(),
    reconciliationSaga(),
  ]);
}
